import { render, staticRenderFns } from "./ViewPayment.vue?vue&type=template&id=0bc0ef80&"
import script from "./ViewPayment.vue?vue&type=script&lang=js&"
export * from "./ViewPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports